<script lang="ts">
    import HelpTooltip from "@/Common/HelpTooltip.svelte";

    // The label of the estimated frontier's mark on a power improvement slider (see assessGoal). withDifficulty: the
    // Preferred Workout Difficulty can be changed where it is shown (the Program page, not the account setup wizard), and a
    // higher one puts more training into each available hour, which raises the frontier.
    export let withDifficulty = false
    $: help = "This represents an estimate of the most you can improve by the target date. " +
        (withDifficulty
            ? "A later target date, more availability or a higher Preferred Workout Difficulty increases it."
            : "A later target date or more availability increases it.")
</script>

<span class="flex items-center text-xs font-medium text-slate-700 whitespace-nowrap">
    Estimated Frontier
    <HelpTooltip message={help} label="What is the estimated frontier?" iconClass="text-gray-500 w-6 h-6"/>
</span>
